import React from 'react';
import { Navbar, Container, Nav, Button, NavDropdown } from 'react-bootstrap';
import { HashLink } from 'react-router-hash-link';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignInAlt, faUserPlus, faUser, faRightFromBracket, faPhoneFlip } from '@fortawesome/free-solid-svg-icons';
import logo from '../../media/logo.png';
import { useNavigate } from 'react-router';
import useAuth from '../../hooks/useAuth';
import profile from '../../media/profile.png';
import './Header.css';

const Header = () => {
    const navigate = useNavigate();
    const { admin, user, logOut } = useAuth();

    return (
        <Navbar expand="xl" style={{
            backgroundColor: 'black'
        }}>
            <Container fluid>
                <Navbar.Brand className="text-white" href="/">
                    <img
                        src={logo}
                        width="150"
                        className="d-inline-block align-top"
                        alt="500 Degrees Steakhouse"
                    />
                </Navbar.Brand>
                <Navbar.Toggle className="bg-light" aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto d-flex align-items-center page-links">
                        <NavLink
                            className={({ isActive }) =>
                                isActive ? "text-warning text-decoration-none nav-link" : "text-white nav-link"
                            }
                            to="/home"
                        >Home</NavLink>
                        <HashLink to="/#specials"
                            className="text-white nav-link me-lg-2"
                        >Specials</HashLink>
                        <NavLink to="/menu"
                            className={({ isActive }) =>
                                isActive ? "text-warning text-decoration-none nav-link" : "text-white nav-link"
                            }>Menu</NavLink>


                        <a target="_blank" href="https://500-degrees-cronulla.square.site/s/order"
                            className="text-white nav-link">
                            Order Online
                        </a>

                        <NavLink to="/book-table" className={({ isActive }) =>
                            isActive ? "text-warning text-decoration-none nav-link" : "text-white nav-link"
                        }>Book Now</NavLink>
                        <NavLink to="/gift-card" className={({ isActive }) =>
                            isActive ? "text-warning text-decoration-none nav-link" : "text-white nav-link"
                        }>Gift Card</NavLink>
                        <NavLink to="/about" className={({ isActive }) =>
                            isActive ? "text-warning text-decoration-none nav-link" : "text-white nav-link"
                        }>About</NavLink>
                        <NavLink to="/blogs" className={({ isActive }) =>
                            isActive ? "text-warning text-decoration-none nav-link" : "text-white nav-link"
                        }>Blogs</NavLink>
                        <NavLink to="/gallery" className={({ isActive }) =>
                            isActive ? "text-warning text-decoration-none nav-link" : "text-white nav-link"
                        }>Gallery</NavLink>


                        <a href="tel:02 9587 5423">
                            <button className="btn btn-success mt-2 mt-xl-0">
                                <FontAwesomeIcon icon={faPhoneFlip} />
                                <span className="ms-2">02 9587 5423</span>
                            </button>
                        </a>


                    </Nav>
                    <Nav className="ms-auto">
                        <div className="d-flex flex-column flex-xl-row mt-2 mt-xl-0">
                            {
                                user.email
                                    ?
                                    <NavDropdown title={
                                        user.photoURL
                                            ?
                                            <img className="rounded-pill" src={user.photoURL} alt={user.displayName} width='40' height='40' />
                                            :
                                            <img src={profile} alt={user.displayName} width='40' height='40' />
                                    } id="profile-dropdown">
                                        <NavDropdown.Item eventKey="4.0" disabled>{user.displayName}</NavDropdown.Item>
                                        {
                                            admin
                                            &&
                                            <NavDropdown.Item eventKey="4.1" onClick={() => {
                                                navigate('/dashboard');
                                            }}><FontAwesomeIcon className="me-2" icon={faUser} /> Dashboard</NavDropdown.Item>

                                        }
                                        <NavDropdown.Item onClick={logOut} eventKey="4.2"><FontAwesomeIcon className="me-2" icon={faRightFromBracket} /> Logout</NavDropdown.Item>
                                    </NavDropdown>
                                    :
                                    <div className="d-flex flex-column flex-xl-row">
                                        <Button className="me-xl-2 rounded-pill" variant="outline-warning" onClick={() => {
                                            navigate('/login');
                                        }}>Login <FontAwesomeIcon icon={faSignInAlt} /></Button>
                                        <Button className="mt-2 mt-xl-0 rounded-pill" variant="warning" onClick={() => {
                                            navigate('/signup');
                                        }}>Sign Up <FontAwesomeIcon icon={faUserPlus} /></Button>
                                    </div>
                            }
                        </div>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar >
    );
};

export default Header;

